<template>
	<v-row>
		<v-col cols="8" height="100%">
			<v-card flat height="100%" :color="color" class="mb-1">
				<p class="display-2 white--text text-center pt-12">{{score}}%</p>
				<p class="white--text text-center">Stufe {{level}}
				</p>
			</v-card>
		</v-col>
		<v-col cols="4">
			<v-row v-for="(l, i) in levels" :key="i" class="mb-1">
				<v-card flat height="40px" width="100%" :color="l.color">
					<v-card-text class="text-center pt-2"><span style="font-size: 1.1em"> {{l.range}}</span> </v-card-text>
					<div class="pointer" v-if="color == l.color" :class="pointerClass"></div>
				</v-card>
			</v-row>
		</v-col>
	</v-row>
</template>

<style lang="less">
	.pointer{

		position: absolute;
		z-index: 0;
		top: 8px;
		right: 70%;
		height: 23px;
		width: 80px;
		// margin-top: 0px;
		// left: -40px;
		// top: 0;
		// width: 100%;
		// height: 40px;
		// &.red--background{
		// 	background-color: #F14336;
		// }
		// &.green--background{
		// 	background-color: #4EAF51;
		// }
		// &.orange--background{
		// 	background-color: red;
		// }
		// &.yellow--background{
		// 	background-color: red;
		// }
	}
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "ScoreScale", 
		props: {
			score: {type: Number}
		},
		data: () => {
			return {
				levels: [
				{ color: "green", range: "76-100%"},
				{ color: "green lighten-2", range: "51-75%"},
				{ color: "yellow", range: "26-50%"},
				{ color: "orange", range: "1-25%"},
				{ color: "red", range: "0%"},
				]
			}
		},
		// components: {

		// },
		computed: {
			color(){
				return this.scoreColor(this.score)
			},
			pointerClass(){
				var obj = {}
				obj[this.color] = true;
				return obj;
			},
			level(){
				if( this.score > 76 ){
					return 5
				}
				if( this.score > 51 ){
					return 4
				}
				if( this.score > 26 ){
					return 3
				}
				if( this.score > 1 ){
					return 2
				}
				return 1
			}
			// ...Vuex.mapState({})
		},
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>